/** Whether a search term matches a row's name or one of its aliases. */
export const matchesNameOrAlias = (
  term: string,
  displayName: string,
  aliases?: string[]
): boolean =>
  displayName.toLowerCase().includes(term) ||
  (aliases ?? []).some(alias => alias.toLowerCase().includes(term));
